import _ from 'underscore';
import $ from 'jquery';

export default class ProductGroupSpecsDialog {
  constructor($scope, $rootScope, ProductService, UserProductService) {
    $scope.tabs = ['Reels Specs', 'Sheets Specs'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.$on('open_product_group_specs_dialog', function(event, args) {
      $scope.product_group_id = args.product_group_id;
      $scope.load_specs(true);
    });

    $scope.load_specs = function(open_dialog) {
      ProductService.get_product_group_specs($scope.product_group_id, null).success(function(data) {
        $scope.specs = data.specs;
        if (open_dialog)
          $scope.open_dialog();
      });
    };

    $scope.set_edit_mode = function(index) {
      $scope.edit_modes[index].enabled = true;
      ProductService.get_product_group_specs($scope.product_group_id, $scope.edit_modes[index].filter).success(function(data) {
        $scope.edit_modes[index].specs = data.specs;
        if (data.specs.length === 0)
          $scope.add_spec(index);
      });
    };

    $scope.set_update_mode = function(index) {
      $scope.edit_modes[index].enabled = false;
      ProductService.update_product_group_specs($scope.product_group_id, $scope.edit_modes[index].specs).success(function(data) {
        if (data.success) {
          $scope.edit_modes[index].specs = [];
          $scope.load_specs(false);
        }
      });
    };

    $scope.add_spec = function(index) {
      var filter = $scope.edit_modes[index].filter;
      var spec = {
        id: null,
        is_reels: filter.is_reels,
        spec_type: filter.spec_type,
        is_accurate: filter.is_accurate
      };
      if (spec.is_accurate == 1) {
        spec.value = 0;
      } else {
        spec.value_min = 0;
        spec.value_max = 0;
      }
      $scope.edit_modes[index].specs.push(spec);
    };

    $scope.show_suggested = function(is_reels) {
      if (is_reels) {
        $scope.suggested_reels = [];
        $scope.loading_suggested_reels = true;
      } else {
        $scope.suggested_sheets = [];
        $scope.loading_suggested_sheets = true;
      }
      UserProductService.get_product_group_specs($scope.product_group_id, is_reels).success(function(data) {
        if (is_reels) {
          $scope.suggested_reels = data.specs;
          $scope.loading_suggested_reels = false;
        } else {
          $scope.suggested_sheets = data.specs;
          $scope.loading_suggested_sheets = false;
        }
      });
    };

    $scope.add_suggested = function(is_reels) {
      var specs = null;
      if (is_reels)
        specs = _.where($scope.suggested_reels, {
          checked: true
        });
      else
        specs = _.where($scope.suggested_sheets, {
          checked: true
        });

      if (specs.length === 0) {
        alert('Please select at least one spec!');
      } else {
        var edit_mode = _.find($scope.edit_modes, function(m) {
          return m.filter.is_reels === is_reels & m.filter.spec_type === specs[0].spec_type && m.filter.is_accurate === specs[0].is_accurate;
        });
        edit_mode.enabled = true;
        _.each(specs, function(s) {
          var spec = {
            id: null,
            is_reels: is_reels,
            spec_type: s.spec_type,
            is_accurate: s.is_accurate,
            value: s.value,
            value_min: s.value_min,
            value_max: s.value_max
          };
          edit_mode.specs.push(spec);
        });
      }

    };

    $scope.open_dialog = function() {
      $.fancybox($('div#product_group_specs_dialog'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes',
        afterClose: function() {
          $rootScope.$broadcast('load_product_group_specs');
        }
      });
    };

    $scope.init_edit_modes = function() {
      $scope.edit_modes = [
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: true,
            is_accurate: true,
            spec_type: 1
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: true,
            is_accurate: false,
            spec_type: 1
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: true,
            is_accurate: true,
            spec_type: 2
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: true,
            is_accurate: false,
            spec_type: 2
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: true,
            is_accurate: false,
            spec_type: 3
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: true,
            is_accurate: false,
            spec_type: 4
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: false,
            is_accurate: true,
            spec_type: 1
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: false,
            is_accurate: false,
            spec_type: 1
          }
        },
        {
          enabled: false,
          specs: [],
          filter: {
            is_reels: false,
            is_accurate: false,
            spec_type: 5
          }
        }
      ];
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.reels_substance_mode = 'both';
      $scope.reels_rw_mode = 'both';
      $scope.sheets_substance_mode = 'both';
      $scope.init_edit_modes();
    };

    $scope.init();

  }
}

ProductGroupSpecsDialog.$inject = ['$scope', '$rootScope', 'ProductService', 'UserProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-group-specs-dialog.ctrl.js